exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Button-module__transparent-button-wrapper___3aJvG{margin:0 auto;font-size:16px}.Button-module__transparent-button-wrapper___3aJvG .Button-module__transparent-button___PgETf{cursor:pointer!important;margin-top:10px;font-family:Circe,Arial,sans-serif;font-size:.8em;font-weight:700;display:flex;align-items:center;justify-content:center;width:auto;min-width:170px;height:3em;padding:0 2em;user-select:none;transition:all .2s ease;letter-spacing:.8px;border-radius:0;color:#fff;border:2px solid #fff;background:transparent;box-sizing:border-box;padding-top:5px!important;transition:.2s}.Button-module__transparent-button-wrapper___3aJvG .Button-module__transparent-button___PgETf:hover{color:#fece15;background:#fff;transition:.2s}", ""]);

// exports
exports.locals = {
	"transparent-button-wrapper": "Button-module__transparent-button-wrapper___3aJvG",
	"transparent-button": "Button-module__transparent-button___PgETf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--6-1!./node_modules/sass-loader/lib/loader.js!./resources/assets/components/UI/ButtonTast/ButtonTransparentWhite/Button.module.scss
// module id = hk5I
// module chunks = 0